// Generated by ts-to-zod
import { z } from "zod";

export const channelListSchema = z.record(z.string(), z.unknown()).and(z.object({
    channels: z.array(z.record(z.string(), z.unknown()).and(z.object({
        channelId: z.number(),
        description: z.string(),
        displayName: z.string(),
        events: z.array(z.record(z.string(), z.unknown()).and(z.object({
            channelId: z.number(),
            description: z.string(),
            displayName: z.string(),
            eventId: z.number(),
            name: z.string()
        }))),
        name: z.string()
    }))),
    message: z.literal("channel-list"),
    trans_id: z.number()
}));

export const channelWithEventsSchema = z.record(z.string(), z.unknown()).and(z.object({
    channelId: z.number(),
    description: z.string(),
    displayName: z.string(),
    events: z.array(z.record(z.string(), z.unknown()).and(z.object({
        channelId: z.number(),
        description: z.string(),
        displayName: z.string(),
        eventId: z.number(),
        name: z.string()
    }))),
    name: z.string()
}));

export const completeSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("complete"),
    success: z.boolean(),
    trans_id: z.number()
}));

export const currentEditorSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("current-editor"),
    project_id: z.number(),
    trans_id: z.number()
}));

export const currentEditorInfoSchema = z.record(z.string(), z.unknown()).and(z.object({
    nickname: z.string().optional().nullable(),
    projectId: z.number(),
    userId: z.number().optional().nullable(),
    username: z.string().optional().nullable()
}));

export const currentEditorResponseSchema = z.record(z.string(), z.unknown()).and(z.object({
    editor: z.record(z.string(), z.unknown()).and(z.object({
        nickname: z.string().optional().nullable(),
        projectId: z.number(),
        userId: z.number().optional().nullable(),
        username: z.string().optional().nullable()
    })),
    message: z.literal("current-editor"),
    trans_id: z.number()
}));

export const dataChangeTypeSchema = z.union([z.literal("versions"), z.literal("workflows"), z.literal("project"), z.literal("project_files"), z.literal("project_constants"), z.literal("workflow_steps"), z.literal("workflow_default_files"), z.literal("workflow_variable_schema")]);

export const dataChangedSchema = z.record(z.string(), z.unknown()).and(z.object({
    change_type: z.union([z.literal("versions"), z.literal("workflows"), z.literal("project"), z.literal("project_files"), z.literal("project_constants"), z.literal("workflow_steps"), z.literal("workflow_default_files"), z.literal("workflow_variable_schema")]),
    context_id: z.number().optional().nullable(),
    message: z.literal("data-changed"),
    project_id: z.number()
}));

export const deliveryMethodSchema = z.union([z.literal("websocket"), z.literal("email"), z.literal("push")]);

export const emptySchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("")
}));

export const entriesSchema = z.record(z.string(), z.unknown()).and(z.object({
    entries: z.array(z.record(z.string(), z.unknown()).and(z.object({
        channelId: z.number(),
        channelName: z.string(),
        entryDate: z.string(),
        entryId: z.number(),
        entryProjectId: z.number().optional().nullable(),
        entrySeen: z.boolean(),
        entryUserId: z.number(),
        eventId: z.number(),
        eventName: z.string(),
        message: z.string(),
        metadata: z.record(z.string(), z.unknown()).optional().nullable(),
        subId: z.number().optional().nullable(),
        subProjectId: z.number().optional().nullable()
    }))),
    message: z.literal("entries"),
    trans_id: z.number()
}));

export const entryInfoSchema = z.record(z.string(), z.unknown()).and(z.object({
    channelId: z.number(),
    channelName: z.string(),
    entryDate: z.string(),
    entryId: z.number(),
    entryProjectId: z.number().optional().nullable(),
    entrySeen: z.boolean(),
    entryUserId: z.number(),
    eventId: z.number(),
    eventName: z.string(),
    message: z.string(),
    metadata: z.record(z.string(), z.unknown()).optional().nullable(),
    subId: z.number().optional().nullable(),
    subProjectId: z.number().optional().nullable()
}));

export const errorSchema = z.record(z.string(), z.unknown()).and(z.object({
    details: z.record(z.string(), z.unknown()).and(z.object({
        description: z.string(),
        error: z.union([z.literal("InvalidArgument"), z.literal("Unsupported"), z.literal("InternalError"), z.literal("EditorLocked"), z.literal("EditorNotLocked")]),
        transId: z.number().optional().nullable()
    })),
    message: z.literal("Error")
}));

export const errorDetailsSchema = z.record(z.string(), z.unknown()).and(z.object({
    description: z.string(),
    error: z.union([z.literal("InvalidArgument"), z.literal("Unsupported"), z.literal("InternalError"), z.literal("EditorLocked"), z.literal("EditorNotLocked")]),
    transId: z.number().optional().nullable()
}));

export const errorTypeSchema = z.union([z.literal("InvalidArgument"), z.literal("Unsupported"), z.literal("InternalError"), z.literal("EditorLocked"), z.literal("EditorNotLocked")]);

export const eventSchema = z.record(z.string(), z.unknown()).and(z.object({
    channelId: z.number(),
    description: z.string(),
    displayName: z.string(),
    eventId: z.number(),
    name: z.string()
}));

export const execStatusSchema = z.union([z.literal("pending"), z.literal("scheduled"), z.literal("executing"), z.literal("canceled"), z.literal("completed"), z.literal("needsreview"), z.literal("rejected"), z.literal("failed"), z.literal("retry"), z.literal("aborted")]);

export const getEntriesSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("get-entries"),
    params: z.record(z.string(), z.unknown()).and(z.object({
        channelId: z.number().optional().nullable(),
        entryId: z.number().optional().nullable(),
        limit: z.number().optional().nullable(),
        offset: z.number().optional().nullable(),
        seen: z.boolean().optional().nullable(),
        since: z.string().optional().nullable(),
        subId: z.number().optional().nullable()
    })),
    trans_id: z.number()
}));

export const getEntriesParamsSchema = z.record(z.string(), z.unknown()).and(z.object({
    channelId: z.number().optional().nullable(),
    entryId: z.number().optional().nullable(),
    limit: z.number().optional().nullable(),
    offset: z.number().optional().nullable(),
    seen: z.boolean().optional().nullable(),
    since: z.string().optional().nullable(),
    subId: z.number().optional().nullable()
}));

export const jobEventSchema = z.record(z.string(), z.unknown()).and(z.object({
    exec_step_id: z.number().optional().nullable(),
    job_id: z.number(),
    kind: z.union([z.literal("job"), z.literal("step")]),
    message: z.literal("job-event"),
    project_id: z.number(),
    routine_id: z.number(),
    status: z.union([z.literal("pending"), z.literal("scheduled"), z.literal("executing"), z.literal("canceled"), z.literal("completed"), z.literal("needsreview"), z.literal("rejected"), z.literal("failed"), z.literal("retry"), z.literal("aborted")]),
    step_id: z.number().optional().nullable(),
    step_index: z.number().optional().nullable()
}));

export const jobExecKindSchema = z.union([z.literal("job"), z.literal("step")]);

export const listChannelsSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("list-channels"),
    trans_id: z.number()
}));

export const listSubscriptionsSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("list-subscriptions"),
    project_id: z.number().optional().nullable(),
    trans_id: z.number()
}));

export const lockEditorSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("lock-editor"),
    project_id: z.number(),
    trans_id: z.number()
}));

export const markSeenSchema = z.record(z.string(), z.unknown()).and(z.object({
    entry_ids: z.array(z.number()),
    message: z.literal("mark-seen"),
    trans_id: z.number()
}));

export const markedSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("marked"),
    trans_id: z.number()
}));

export const newEntriesSchema = z.record(z.string(), z.unknown()).and(z.object({
    entries: z.array(z.record(z.string(), z.unknown()).and(z.object({
        channelId: z.number(),
        channelName: z.string(),
        entryDate: z.string(),
        entryId: z.number(),
        entryProjectId: z.number().optional().nullable(),
        entrySeen: z.boolean(),
        entryUserId: z.number(),
        eventId: z.number(),
        eventName: z.string(),
        message: z.string(),
        metadata: z.record(z.string(), z.unknown()).optional().nullable(),
        subId: z.number().optional().nullable(),
        subProjectId: z.number().optional().nullable()
    }))),
    message: z.literal("new-entries")
}));

export const subscribeSchema = z.record(z.string(), z.unknown()).and(z.object({
    delivery_methods: z.array(z.union([z.literal("websocket"), z.literal("email"), z.literal("push")])).optional().nullable(),
    event_id: z.number(),
    message: z.literal("subscribe"),
    project_id: z.number().optional().nullable(),
    trans_id: z.number()
}));

export const subscribedSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("subscribed"),
    subscription: z.record(z.string(), z.unknown()).and(z.object({
        channelId: z.number(),
        channelName: z.string(),
        dateSubscribed: z.string(),
        deliveryMethods: z.array(z.union([z.literal("websocket"), z.literal("email"), z.literal("push")])),
        eventId: z.number(),
        eventName: z.string(),
        lastChecked: z.string(),
        projectId: z.number().optional().nullable(),
        subId: z.number(),
        userId: z.number()
    })),
    trans_id: z.number()
}));

export const subscriptionInfoSchema = z.record(z.string(), z.unknown()).and(z.object({
    channelId: z.number(),
    channelName: z.string(),
    dateSubscribed: z.string(),
    deliveryMethods: z.array(z.union([z.literal("websocket"), z.literal("email"), z.literal("push")])),
    eventId: z.number(),
    eventName: z.string(),
    lastChecked: z.string(),
    projectId: z.number().optional().nullable(),
    subId: z.number(),
    userId: z.number()
}));

export const subscriptionListSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("subscription-list"),
    subscriptions: z.array(z.record(z.string(), z.unknown()).and(z.object({
        channelId: z.number(),
        channelName: z.string(),
        dateSubscribed: z.string(),
        deliveryMethods: z.array(z.union([z.literal("websocket"), z.literal("email"), z.literal("push")])),
        eventId: z.number(),
        eventName: z.string(),
        lastChecked: z.string(),
        projectId: z.number().optional().nullable(),
        subId: z.number(),
        userId: z.number()
    }))),
    trans_id: z.number()
}));

export const unlockEditorSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("unlock-editor"),
    project_id: z.number(),
    trans_id: z.number()
}));

export const unsubscribeSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("unsubscribe"),
    sub_id: z.number(),
    trans_id: z.number()
}));

export const unsubscribedSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("unsubscribed"),
    trans_id: z.number()
}));

export const watchEditorsSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("watch-editors"),
    trans_id: z.number(),
    watch: z.boolean()
}));

export const watchJobEventsSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("watch-job-events"),
    project_id: z.number(),
    trans_id: z.number(),
    watch: z.boolean()
}));

export const watchProjectDataSchema = z.record(z.string(), z.unknown()).and(z.object({
    message: z.literal("watch-project-data"),
    project_id: z.number(),
    trans_id: z.number(),
    watch: z.boolean()
}));
